import { GridsterItem } from 'angular-gridster2';
import { ApprovalStatus } from '@shared/modules/approvals/approvals.types';
import { JupiterPanelDef } from '@modules/jupiter/@components/panels/types';

// ── API response shapes ────────────────────────────────────────────────────────

export interface EligibleApprover {
  id: number;
  name: string;
  avatar_url: string;
}

export interface ApprovalItem {
  id: number;
  assigned_user: { id: number; name: string; email: string; avatar_url: string };
  status: ApprovalStatus;
  comments: string;
}

export interface ApprovalProcess {
  id: number;
  name: string;
  related_to_type: string;
  related_to_id: number;
  status: ApprovalStatus;
  snapshot: Record<string, any>;
  layout_definition: { tab?: ApprovalPanelItem[] };
  approvals: ApprovalItem[];
  current_user_approval: ApprovalItem | null;
  created_by: { id: number; name: string; email: string; avatar_url: string };
  progress: { total: number; approved: number; declined: number; pending: number };
  created_at: string | null;
  completed_at: string | null;
}

// ── Domain types ───────────────────────────────────────────────────────────────

export interface ApprovalPanelItem extends GridsterItem {
  panel: JupiterPanelDef<any>;
}

// ── NgXS state ─────────────────────────────────────────────────────────────────

export interface ApprovalsStateModel {
  approvals: ApprovalProcess[];
  eligibleApprovers: EligibleApprover[];
  loading: boolean;
  activeApprovalId: number | null;
}

// ── Approval-template internal types ──────────────────────────────────────────

export interface TabOption {
  id: any;
  name: string;
}

export interface GridPanel {
  x: number;
  y: number;
  cols: number;
  rows: number;
  id: string;
}

// ── UI display maps ────────────────────────────────────────────────────────────

export const STATUS_BADGE: Record<ApprovalStatus, { label: string; type: string }> = {
  [ApprovalStatus.APPROVED]: { label: 'Approved', type: 'success' },
  [ApprovalStatus.NOT_YET]: { label: 'Pending', type: 'warning' },
  [ApprovalStatus.DECLINED]: { label: 'Changes requested', type: 'danger' },
  [ApprovalStatus.NONE]: { label: 'Not started', type: 'default' },
  [ApprovalStatus.NOT_SENT]: { label: 'Not sent', type: 'default' },
};

/** null = covered cell (skip rendering; its slot is owned by a rowspan/colspan above) */
export interface TableCell {
  colspan: number;
  rowspan: number;
  panelId: string | null;
  title: string | null;
  type: string | null;
}

export interface EnrichedTab {
  id: any;
  name: string;
  rows: Array<Array<TableCell | null>>;
  rawLayout: GridPanel[];
  rawPanels: any[];
}
